/* InviteCodePanel.tsx
   ------------------------------------------------------------------ */
import React from 'react';
import {IconButton, Button} from '@material-ui/core';
import {useSelector} from 'react-redux';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faQrcode} from '@fortawesome/pro-regular-svg-icons';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import {RootState} from 'appredux/reducers';
import {_GetInviteUrlRoot} from './utils/index';
import {NavigationService} from 'services/index';
import ShareInviteCode from './components/ShareInviteCode';
import QrCodeToolTip from './components/QRCodeToolTip';

import './InviteCodePanel.scss';

interface Props {
  /** When rendered outside the Customers page we show a link to it */
  notInCustomers?: boolean;
}

export default function InviteCodePanel({notInCustomers}: Props) {
  /* ------------------ build invite URL for current user ------------------ */
  const inviteCode = useSelector(
    (s: RootState) => s.user?.inviteCode ?? 'demo',
  );
  const fullInviteUrl = `${_GetInviteUrlRoot()}/${inviteCode}`;

  return (
    <div className="panel-container">
      {/* ── TOP ROW ─────────────────────────────────────────────────────── */}
      <div className="panel-row">
        {/* left: heading & sub-heading */}
        <div className="title-group">
          <h3 className="panel-title">Manage your customers with Khula CRM</h3>
          <p className="panel-subtitle">
            Digital, more professional, and closer to your customers than ever
            before
          </p>
        </div>

        {/* right: invite URL + copy chip + QR icon */}
        <div className="share-group">
          <ShareInviteCode url={fullInviteUrl} />

          <QrCodeToolTip url={fullInviteUrl} inviteCode={inviteCode}>
            <IconButton
              className="qr-btn"
              aria-label="show QR code"
              size="medium"
            >
              <FontAwesomeIcon icon={faQrcode} />
            </IconButton>
          </QrCodeToolTip>
        </div>
      </div>

      {/* ── OPTIONAL LINK ──────────────────────────────────────────────── */}
      {notInCustomers && (
        <div className="view-customers">
          <Button
            color="primary"
            onClick={() => NavigationService.navigate('/customers/')}
            endIcon={<ChevronRightIcon />}
          >
            View Customers
          </Button>
        </div>
      )}
    </div>
  );
}
